import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import { EstablishmentMainForm } from "./forms/establishment-main.form";
import { EstablishmentFeaturesForm } from "./forms/establishment-features.form";
import { EstablishmentSEOForm } from "./forms/establishment-SEO.form";
import { EstablishmentServicesForm } from "./forms/establishment-services.form";
import {
  Typography,
  CircularProgress,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import AlertDialog from "../components/alert.component";
import Button from "@material-ui/core/Button";

class EstablishmentView extends Component {
  state = {
    establishment: null,
    establishmentGroup: null,
    userRole: null,
    isPublished: false,
    photosChecked: false,
    photosDisabled: false,
    inSocialCharter: false,
    isActive: false,
    blockCommoditiesProfessionalArea: false,
    disabledDescriptionEdition: false,
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
    services: null,
    servicesComboboxes: null,
    isUpdating: false,
    valence_id: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.getUserRole = this.getUserRole.bind(this);
    this.getEstablishment = this.getEstablishment.bind(this);
    this.updateEstablishment = this.updateEstablishment.bind(this);
    this.getEstablishmentGroup = this.getEstablishmentGroup.bind(this);
    this.getServices = this.getServices.bind(this);
    this.getServicesComboboxes = this.getServicesComboboxes.bind(this);
    this.updateMain = this.updateMain.bind(this);
    this.updateFeatures = this.updateFeatures.bind(this);
    this.updateServices = this.updateServices.bind(this);
    this.updateSEO = this.updateSEO.bind(this);
    this.changeIsPublished = this.changeIsPublished.bind(this);
    this.changePhotosChecked = this.changePhotosChecked.bind(this);
    this.changePhotosDisabled = this.changePhotosDisabled.bind(this);
    this.changeInSocialCharter = this.changeInSocialCharter.bind(this);
    this.deleteEstablishment = this.deleteEstablishment.bind(this);
    this.changeBlockCommoditiesProfessionalArea =
      this.changeBlockCommoditiesProfessionalArea.bind(this);
    this.changeDisabledDescriptionEdition =
      this.changeDisabledDescriptionEdition.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  /**
   *
   */

  componentDidMount() {
    const { id } = this.props.match.params;
    this.getUserRole();
    this.getEstablishment(id);
    this.getServices(id);
    this.getServicesComboboxes(id);
  }

  // obter o role do user logado
  getUserRole = () => {
    this.api
      .get(`/admins/${localStorage.id}`, {}, true)
      .then(({ data: admin }) => {
        this.setState({ userRole: admin.id_group });
      });
  };

  getEstablishment(id) {
    this.api.get(`establishments/${id}`).then(({ data = null }) => {
      this.setState({ establishment: data });
      this.setState({ isPublished: data.is_published });
      this.setState({ photosChecked: data.photos_checked });
      this.setState({ photosDisabled: data.photos_disabled });
      this.setState({ inSocialCharter: data.in_social_charter });
      this.setState({ isActive: data.is_active });
      this.setState({
        blockCommoditiesProfessionalArea:
          data.block_commodities_professional_area,
      });
      this.setState({
        disabledDescriptionEdition: data.disabled_description_edition,
      });
      this.setState({ valence_id: data.valence_id });
      if (data.group_id != null) {
        this.getEstablishmentGroup(data.group_id);
      } else {
        return;
      }
    });
  }

  getEstablishmentGroup({ group = this.state.establishment.group_id }) {
    this.api.get(`establishments/`, { group }).then(({ data = null }) => {
      this.setState({ establishmentGroup: data });
      return data;
    });
  }

  updateEstablishment(dados) {
    const { id } = this.props.match.params;
    this.api.patch(`establishment_valences/${id}`, { ...dados });
    this.api
      .patch(`establishments/${id}`, { ...dados })
      .then(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({ isPublished: data.is_published });
        this.setState({ photosChecked: data.photos_checked });
        this.setState({ photosDisabled: data.photos_disabled });
        this.setState({ inSocialCharter: data.in_social_charter });
        this.setState({ isActive: data.is_active });
        this.setState({
          blockCommoditiesProfessionalArea:
            data.block_commodities_professional_area,
        });
        this.setState({
          disabledDescriptionEdition: data.disabled_description_edition,
        });
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
        });
        return data;
      })
      .catch(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
        });
        return data;
      });
  }

  getServices(id) {
    this.api
      .get(`services?id_establishment=${id}&input=options`)
      .then(({ data = null }) => {
        this.setState({ services: data });
        return data;
      });
  }

  getServicesComboboxes(id) {
    this.api
      .get(`services?id_establishment=${id}&input=comboboxes`)
      .then(({ data = null }) => {
        this.setState({ servicesComboboxes: data });
        return data;
      });
  }

  updateMain(dados) {
    const { id } = this.props.match.params;
    this.api.patch(
      `establishment_valences/${this.state.establishment.establishments_valences_id}`,
      { ...dados }
    );
    this.api
      .patch(`establishments/${id}`, { ...dados })
      .then(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
        });
        return data;
      })
      .catch(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
        });
        return data;
      });
  }

  updateFeatures(dados) {
    this.api
      .patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { ...dados }
      )
      .then(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
        });
        return data;
      })
      .catch(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
        });
        return data;
      });
  }

  updateServices(dados) {
    this.state.isUpdating = true;
    const { id } = this.props.match.params;
    const services = this.state.services;
    const arraydados = Object.entries(dados);
    const cloneservices = JSON.parse(JSON.stringify(this.state.services));
    for (let k = 0; k < arraydados.length; k++) {
      for (let z = 0; z < services.length; z++) {
        if (arraydados[k][0] === services[z].checkboxes) {
          cloneservices[z].activeUpdate = arraydados[k][1];
          break;
        }
        if (arraydados[k][0] === services[z].checkboxes + "_cb") {
          cloneservices[z].valueid = arraydados[k][1];
          break;
        }
        cloneservices[z].establishment_id = arraydados[0][1];
      }
    }

    this.api
      .patch(`services/${id}`, {
        data: cloneservices,
        length: cloneservices.length,
      })
      .then(({ cloneservices = null }) => {
        this.getServices(id);
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
          isUpdating: false,
        });
        return cloneservices;
      })
      .catch(({ cloneservices = null }) => {
        this.setState({ services: cloneservices });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
          isUpdating: false,
        });
        return cloneservices;
      });
  }

  updateSEO(dados) {
    this.api
      .patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { ...dados }
      )
      .then(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Dados atualizados com sucesso",
        });
        return data;
      })
      .catch(({ data = null }) => {
        this.setState({ establishment: data });
        this.setState({
          showAlert: true,
          alertTitle: "Erro",
          alertMessage: "Ocorreu um erro",
        });
        return data;
      });
  }

  // BOTAO ESTÁ PUBLICADO - qd está activo, o equipamento aparece no site
  changeIsPublished() {
    if (this.state.isPublished === false) {
      this.setState({ isPublished: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { is_published: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ isPublished: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { is_published: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  // BOTAO Fotografias Certificadas
  changePhotosChecked() {
    if (this.state.photosChecked === false) {
      this.setState({ photosChecked: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { photos_checked: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ photosChecked: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { photos_checked: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  // BOTAO Esconder Fotografias
  changePhotosDisabled() {
    if (this.state.photosDisabled === false) {
      this.setState({ photosDisabled: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { photos_disabled: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ photosDisabled: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { photos_disabled: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  // BOTAO Equipamento na Carta Social
  changeInSocialCharter() {
    if (this.state.inSocialCharter === false) {
      this.setState({ inSocialCharter: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { in_social_charter: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ inSocialCharter: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { in_social_charter: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  // BOTAO Elimina Equipamento - Equipamento desaparece do BO e do site
  // Altera o input "Publicado" (site)
  deleteEstablishment = () => {
    this.api
      .patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { is_active: 0, is_published: 0 }
      )
      .then(
        this.setState({
          showAlert: true,
          alertTitle: "Sucesso",
          alertMessage: "Eliminado com sucesso",
        })
      )
      .then(window.location.replace("/establishments"));
  };

  // BOTAO Bloquear edição de comodidades na Área Profissional
  changeBlockCommoditiesProfessionalArea() {
    if (this.state.blockCommoditiesProfessionalArea === false) {
      this.setState({ blockCommoditiesProfessionalArea: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { block_commodities_professional_area: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ blockCommoditiesProfessionalArea: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { block_commodities_professional_area: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  // BOTAO Bloquear edição de comodidades na Área Profissional
  changeDisabledDescriptionEdition() {
    if (this.state.disabledDescriptionEdition === false) {
      this.setState({ disabledDescriptionEdition: true });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { disabled_description_edition: 1 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    } else {
      this.setState({ disabledDescriptionEdition: false });
      this.api.patch(
        `establishment_valences/${this.state.establishment.establishments_valences_id}`,
        { disabled_description_edition: 0 }
      );
      this.setState({
        showAlert: true,
        alertTitle: "Sucesso",
        alertMessage: "Atualizado com sucesso",
      });
    }
  }

  showAlert() {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: <p>Eliminar equipamento</p> });
    this.setState({
      alertMessage: (
        <div>
          <p>
            Tem a certeza que deseja eliminar este equipamento (o histórico de
            faturação continuará visível)?
          </p>
          <p className="text-center">
            <Button
              className="button_delete_entity_or_establishment"
              onClick={this.deleteEstablishment}
            >
              Sim
            </Button>
          </p>
        </div>
      ),
    });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }
  /**
   *
   */

  renderDetails() {
    let establishmentGroup = this.state.establishmentGroup
      ? this.state.establishmentGroup.establishments
      : 0;
    let establishmentGroupList = establishmentGroup ? establishmentGroup : 0;
    console.log(establishmentGroupList);
    let establishment = this.state;

    return (
      <>
        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Geral
          </Typography>
          <EstablishmentMainForm
            onSubmit={this.updateMain}
            establishment={this.state.establishment}
          />
        </div>

        {this.state.userRole === 2 &&
          establishment.establishment.valence_id === 2 &&
          (establishment.establishment.plan_id === 1 ||
            establishment.establishment.plan_id === null) && (
            <div className="delete-establishment-container">
              <div className="text-right">
                <Button
                  variant="contained"
                  size="small"
                  onClick={this.showAlert}
                >
                  Eliminar Equipamento
                </Button>
              </div>
            </div>
          )}

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Características
          </Typography>
          <EstablishmentFeaturesForm
            onSubmit={this.updateFeatures}
            establishment={this.state.establishment}
          />
        </div>

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Controlos
          </Typography>
          <FormGroup>
            <div class="row">
              <div class="col-2">
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.isPublished}
                          onChange={this.changeIsPublished}
                        />
                      }
                      label="Publicado"
                    />
                  )}
                  <div class="small pl-2 text-secondary font-italic">
                    Ao desativar, o Equipamento deixará de aparecer no site mas
                    continua a existir no BO
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.photosDisabled}
                          onChange={this.changePhotosDisabled}
                        />
                      }
                      label="Esconder Fotografias"
                    />
                  )}
                </div>
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.inSocialCharter}
                          onChange={this.changeInSocialCharter}
                        />
                      }
                      label="Equipamento na Carta Social"
                    />
                  )}
                </div>
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.photosChecked}
                          onChange={this.changePhotosChecked}
                        />
                      }
                      label="Fotografias Certificadas"
                    />
                  )}
                </div>
              </div>
              <div class="col-4">
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.blockCommoditiesProfessionalArea}
                          onChange={this.changeBlockCommoditiesProfessionalArea}
                        />
                      }
                      label="Bloquear edição de comodidades na Área Profissional"
                    />
                  )}
                </div>
                <div>
                  {establishment && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.disabledDescriptionEdition}
                          onChange={this.changeDisabledDescriptionEdition}
                        />
                      }
                      label="Bloquear edição de descrições na Área Profissional"
                    />
                  )}
                </div>
              </div>
            </div>
          </FormGroup>
        </div>

        <div
          className={
            establishmentGroupList === 0 ? "d-none" : "main-reqlist-container"
          }
        >
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Grupo de Equipamentos nº {this.state.establishment.group_id}
          </Typography>
          <ul>
            {establishmentGroupList &&
              establishmentGroupList.map((group) => (
                <li class="pb-2">
                  <a href={group.id}>{group.name}</a>
                </li>
              ))}
          </ul>
        </div>

        <AlertDialog
          open={this.state.showAlert}
          handleClose={() => {
            this.setState({ showAlert: false });
          }}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>

        {this.state.services && this.state.valence_id === 2 && (
          <div className="main-reqlist-container">
            <Typography
              variant="h6"
              color="#505e6b"
              gutterBottom
              style={{ marginBottom: "20px" }}
            >
              Serviços
            </Typography>
            <EstablishmentServicesForm
              onSubmit={this.updateServices}
              establishment={this.state.establishment}
              services={this.state.services}
              servicesComboboxes={this.state.servicesComboboxes}
              isUpdating={this.state.isUpdating}
            />
          </div>
        )}

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            SEO
          </Typography>
          <EstablishmentSEOForm
            onSubmit={this.updateSEO}
            establishment={this.state.establishment}
          />
        </div>

        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </>
    );
  }

  render() {
    let establishment = this.state.establishment;

    return establishment ? (
      this.renderDetails()
    ) : (
      <div>
        <CircularProgress
          color="secondary"
          style={{ position: "absolute", top: "50%", left: "50%" }}
        />
      </div>
    );
  }
}

export default withRouter(EstablishmentView);
